import * as React from 'react';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { RouteComponentProps } from 'react-router';
import { ScoreboardTabel } from '../../models/ScoreboardTabel';
import ScoreboardTabelPresenter from './ScoreboardTabelPresenter';
import { Redirect } from 'react-router-dom';
import { Form, Row, Col } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { DropDownFormGroup, MenuItemDto } from '../../uiComponents/input/FormGroups';
import SubmitButton from '../../uiComponents/input/SubmitButton';
import { ScoreboardKonfiguration } from '../../models/ScoreboardKonfiguration';
import { Spinner } from '../../uiComponents/Spinner';
import { KonkurrenceResultat } from '../../models/KonkurrenceResultat';

export interface ScoreboardContainerProps extends RouteComponentProps<any> {
}

export interface ScoreboardContainerState {
    konkurrenceResultatTable?: ScoreboardTabel;
    closing: boolean;
    sortedColumnName: string;
    konfigurationId?: string;
    isSubmitting: boolean;
    alleKonfigurationer?: ScoreboardKonfiguration[];
    resultaterToShow: KonkurrenceResultat[];
    indexStart: number;
    indexEnd: number;
}

export default class ScoreboardContainer extends React.Component<ScoreboardContainerProps, ScoreboardContainerState> {

    private readonly rowsToShow: number = 5;
    private _dataInterval: any | undefined;
    public get dataInterval(): any | undefined {
        return this._dataInterval;
    }
    public set dataInterval(v: any | undefined) {
        this._dataInterval = v;
    }

    constructor(props: ScoreboardContainerProps) {
        super(props);
        this.state = {
            konkurrenceResultatTable: undefined,
            closing: false,
            sortedColumnName: 'hold',
            konfigurationId: undefined,
            isSubmitting: false,
            alleKonfigurationer: undefined,
            resultaterToShow: new Array(0),
            indexStart: 0,
            indexEnd: this.rowsToShow,
        };


        this.onClose = this.onClose.bind(this);
        this.onColHeaderClick = this.onColHeaderClick.bind(this);
    }

    componentDidMount() {
        let self = this;
        const konkurrenceId = this.props.match.params.id;
        createApiCaller().getAllScoreboardKonfigurationer(konkurrenceId)
            .then(response => {
                self.setState({ alleKonfigurationer: response });
            });
    }

    componentWillUnmount() {
        clearInterval(this.dataInterval);
    }

    onClose() {
        this.setState({ closing: true });
    }

    sortResults(colName: string, konkurrenceResultatTable?: ScoreboardTabel): ScoreboardTabel {
        if (konkurrenceResultatTable === undefined) {
            throw Error('konkurrenceResultatTable er undefined');
        }

        if (konkurrenceResultatTable.ingenKonfiguration) {
            return konkurrenceResultatTable;
        }

        let sortedResultat = konkurrenceResultatTable.resultater;
        if (colName === 'samlet') {
            sortedResultat = konkurrenceResultatTable.resultater.sort((a, b) => b.samletAntalPoint - a.samletAntalPoint);
        } else if (colName === 'hold') {
            sortedResultat = konkurrenceResultatTable.resultater.sort((a, b) => (a.institution + a.holdNavn).localeCompare(b.institution + b.holdNavn));
        } else {
            sortedResultat = konkurrenceResultatTable.resultater.sort(
                (a, b) =>
                    (b.opgaveDelopgavePlaceringer.filter(d => d.id === colName)[0].antalPoint) -
                    (a.opgaveDelopgavePlaceringer.filter(d => d.id === colName)[0].antalPoint)
            );
        }

        konkurrenceResultatTable.resultater = sortedResultat;

        return konkurrenceResultatTable;
    }

    onColHeaderClick(colName: string) {
        this.setState({ sortedColumnName: colName }, () => {
            const sortetScoreboardTabel = this.sortResults(this.state.sortedColumnName, this.state.konkurrenceResultatTable);
            this.setState({ resultaterToShow: sortetScoreboardTabel.resultater.slice(0, this.rowsToShow) });
        });
    }

    onKonfigurationSelectedChange = (value: string) => {
        this.setState({ konfigurationId: value });
    }

    getData = () => {
        const konkurrenceId = this.props.match.params.id;
        if (this.state.konfigurationId !== undefined) {
            createApiCaller().GetKonkurrenceResultat(konkurrenceId, this.state.konfigurationId).then(response => {
                this.setState({ konkurrenceResultatTable: response });
                if (this.dataInterval === undefined) {
                    this.dataInterval = setInterval(this.getData, 5000);
                }

                const sortetScoreboardTabel = this.sortResults(this.state.sortedColumnName, response);

                if (sortetScoreboardTabel.resultater) {
                    this.setState({ resultaterToShow: sortetScoreboardTabel.resultater.slice(this.state.indexStart, this.state.indexEnd) });

                    if (this.state.konkurrenceResultatTable) {
                        if (this.state.indexEnd >= this.state.konkurrenceResultatTable.resultater.length) {
                            this.setState({ indexStart: 0, indexEnd: this.rowsToShow });
                        } else {
                            this.setState({ indexStart: this.state.indexStart + this.rowsToShow, indexEnd: this.state.indexEnd + this.rowsToShow });
                        }
                    }
                }
            });
        }
    }

    vaelgKonfigurationSubmit = () => {
        this.getData();
    }

    getKonfigurations = () => {
        if (this.state.alleKonfigurationer !== undefined) {
            return this.state.alleKonfigurationer.map((k, i) => {
                return new MenuItemDto(k.id, k.navn);
            });
        }

        return new Array<MenuItemDto>();
    }

    render() {
        if (this.state.closing) {
            return <Redirect to='/' />;
        }

        if (this.state.konfigurationId === undefined || this.state.konkurrenceResultatTable === undefined) {
            return (
                <div>
                    <div className='konfiguration-vaelger'>
                        {this.state.alleKonfigurationer === undefined &&
                            <Spinner />
                        }

                        {this.state.alleKonfigurationer !== undefined &&
                            <div>
                                <h1>Vælg konfiguration</h1>

                                <Form onSubmit={this.vaelgKonfigurationSubmit}>
                                    <Row>
                                        <Col mdOffset={1} md={10}>
                                            <DropDownFormGroup
                                                items={this.getKonfigurations()}
                                                name='konfiguration'
                                                label=''
                                                selectedValue={this.state.konfigurationId}
                                                onChange={(fieldName: string, value: any) => this.onKonfigurationSelectedChange(value)}
                                                ingenValgtText='Vælg konfiguration'
                                            />
                                        </Col>
                                    </Row>
                                    <SubmitButton isSubmitting={this.state.isSubmitting}>Vælg konfiguration</SubmitButton>
                                </Form>
                            </div>
                        }
                    </div>
                </div>
            );
        }

        if (this.state.konkurrenceResultatTable === undefined) {
            return (
                <div />
            );
        }

        const showSamletPlacering = this.state.konkurrenceResultatTable.showSamletPlacering;

        return (
            <div>
                <ScoreboardTabelPresenter
                    konkurrenceResultatTabel={this.sortResults(this.state.sortedColumnName, this.state.konkurrenceResultatTable)}
                    onClose={this.onClose}
                    onColHeaderClick={this.onColHeaderClick}
                    sortedColumnName={this.state.sortedColumnName}
                    showSamletPlacering={showSamletPlacering}
                    resultaterToShow={this.state.resultaterToShow}
                />
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/Scoreboard/ScoreboardContainer.tsx